/**
 * SlotGrid — time slot selector grid for booking flows.
 * Shows available time slots with bay info, disabled/selected states.
 */
import { cn } from "@/lib/utils";

export interface SlotOption {
  key: string;
  label: string;
  bay?: string;
  disabled?: boolean;
}

interface SlotGridProps {
  slots: SlotOption[];
  selected: string | null;
  onSelect: (key: string) => void;
  label?: string;
  className?: string;
}

export const SlotGrid = ({
  slots,
  selected,
  onSelect,
  label = "Available slots",
  className,
}: SlotGridProps) => {
  return (
    <div className={cn("mt-2", className)}>
      <div className="text-[10px] font-bold uppercase tracking-widest mb-1.5 text-gray3">
        {label}
      </div>
      <div className="grid grid-cols-4 gap-1.5">
        {slots.map((s) => {
          const on = selected === s.key;
          const disabled = s.disabled;
          return (
            <button
              key={s.key}
              onClick={() => !disabled && onSelect(s.key)}
              disabled={disabled}
              className={cn(
                "py-2 rounded-md text-center text-[12px] font-semibold border-[1.5px] transition-all duration-150",
                disabled && "bg-gray7 text-gray5 border-gray6 cursor-not-allowed line-through",
                !disabled && on && "bg-green2 text-white border-green2",
                !disabled && !on && "bg-white text-black1 border-gray6 hover:border-greentab cursor-pointer"
              )}
            >
              {s.label}
              {s.bay && (
                <div className="text-[9px] font-normal opacity-80">
                  {s.bay}
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};
